module.exports = __webpack_public_path__ + "img/soccer_ball.e7c54eb4.jpg";